/**
 * Handles Product Removal from Bag
 * @module removeItem
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'removeItem';

export const CLICK_EVENT = 'click';
export const RI_WRAPPER_CLASS = '.js-item-wrapper';
export const RI_ITEM_CLASS = '.js-item';
export const RI_REMOVE_CLASS = '.js-remove-item';
export const RI_RESTORE_CLASS = '.js-restore-item';
export const RI_ITEM_NOTIFICATION_CLASS = '.js-item-notification';

const SITE_FLAG = 'S';

export const DEFAULTS = {

};
/**
 * Hide Product with a setTimeout to remove permanently
 * @param  {boolean} $el - element
 */
const hideProduct = ($el, $riItemRemoveLink) => {
  const fadeInNotification = () => {
    $riItemRemoveLink.parents(RI_ITEM_CLASS).siblings(RI_ITEM_NOTIFICATION_CLASS).fadeIn();
  };
  $riItemRemoveLink.parents(RI_ITEM_CLASS).fadeOut(fadeInNotification);
};
/**
 * Undo product removal
 * @param  {jQuery} $el - element
 */
const restoreProduct = ($el) => {
  const fadeInItem = () => {
    const qtySelect = $el.find('select[name="quantity"]');
    const previousQuantity = qtySelect.length > 0 ? qtySelect.data('qty') : 1;
    const code = $el.data('code');
    const size = $el.data('size');
    const isoos = $el.data('isoos').toString();
    const sectionurl = $el.data('sectionurl');
    const sessionid = $el.data('sessionid');
    const dept = $el.data('dept');
    const csrfhash = $el.data('csrfhash');
    const giftCardInfo = $el.find('.js-gift-card-info');
    const giftCardTo = giftCardInfo.length > 0 ? giftCardInfo.data('to') : null;
    const giftCardMsg = giftCardInfo.length > 0 ? giftCardInfo.data('msg') : null;
    const isMens = false;

    if (isoos === 'false') {
      if ($.isFunction(window.restoreProductByAddAgain)) {
/**
 * restoreProductByAddAgain
 * This function is in /repo/src/templates/lovers_friends/checkout/ShoppingBag.vm
 */
        window.restoreProductByAddAgain(code, size, sectionurl, sessionid, previousQuantity, null, csrfhash, null, isMens, 'addToBag', null, true, dept, $el, qtySelect, previousQuantity, giftCardTo, giftCardMsg);
      } else {
        console.log('restoreProductByAddAgain function is missing!'); // eslint-disable-line no-console
      }
    } else {
      console.log('Product is out of stock!'); // eslint-disable-line no-console
    }
  };
  $el.find(RI_ITEM_NOTIFICATION_CLASS).fadeOut(fadeInItem);
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, $riItemRemoveLink, opts) => {
  const element = $el;
  const removeItemObj = {
    setup: () => {
      $.ajax({
        type: 'POST',
        url: '/r/ajax/RemoveFromBag.jsp',
        data: $.param({
          code: $(element).data('code'),
          size: $(element).data('size'),
          serial: $(element).data('serial'),
          useKeys: true,
          site: SITE_FLAG,
        }),
        success: (obj) => {
          $(document).trigger('bag:removeFromBag', $.parseJSON(obj));
          if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
            window.PAGE_TRACK_A_MODULE.insertEventTrack('shopping_bag', 'remove_item');
          }
          if (typeof window.getBagItemsAndRefreshCache !== 'undefined' && $.isFunction(window.getBagItemsAndRefreshCache)) {
            window.getBagItemsAndRefreshCache();
          }
          hideProduct($el, $riItemRemoveLink, opts);
          element.removeItemTimeout = window.setTimeout(() => {
            element.remove();
          }, 5000);
        },
      });
    },
    cancel: () => {
      window.clearTimeout(element.removeItemTimeout);
    },
  };
  $riItemRemoveLink
  .on(CLICK_EVENT, (evt) => {
    evt.preventDefault();
    removeItemObj.setup();
  });

  $el
  .on(CLICK_EVENT, RI_RESTORE_CLASS, (evt) => {
    evt.preventDefault();
    restoreProduct($el, opts);
    removeItemObj.cancel();
  });
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - dropdown wrap
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function removeItem(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const $riItemRemoveLink = $el.find(RI_REMOVE_CLASS);

  setEventListeners($el, $riItemRemoveLink, opts);
}

registerJQueryPlugin(PLUGIN_NAME, removeItem);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-remove-item.js